module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    staticClass: "form-control capitalize",
    domProps: {
      "value": this.status
    },
    on: {
      "change": function($event) {
        return _vm.saveStatus($event)
      }
    }
  }, _vm._l((this.statusOptions), function(statusOption) {
    return _c('option', {
      staticClass: "capitalize",
      domProps: {
        "value": statusOption
      }
    }, [_vm._v(" " + _vm._s(statusOption.toLowerCase()) + " ")])
  }), 0)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 new-tag-item"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Add new tag",
      "track-by": "name",
      "options": _vm.tagOptions,
      "multiple": true,
      "taggable": true,
      "custom-label": _vm.optionLabelFormatter,
      "closeOnSelect": false,
      "showLabels": false
    },
    on: {
      "tag": _vm.tagNameConverter
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedTags.length
    },
    on: {
      "click": _vm.saveTags
    }
  }, [_vm._v("\n              Add\n            ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tag-items"
  }, [(!_vm.associatedTags.length) ? [_c('p', [_vm._v("No associated tags")])] : _vm._e(), _vm._v(" "), (_vm.associatedTags.length) ? _vm._l((_vm.associatedTags), function(tag) {
    return _c('span', {
      staticClass: "tag-item",
      on: {
        "click": function($event) {
          return _vm.searchTag(tag.name)
        }
      }
    }, [_c('span', {
      staticClass: "label label-default"
    }, [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-close clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Remove tag"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeTag(tag)
        }
      }
    })])
  }) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Signaletics")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfc5083c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Signaletics.vue
// module id = 455
// module chunks = 1